// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__26CfA","footer":"ReportModalFilter_footer__2GAwD"};